// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"31f8622d","498":"867d9c88","513":"9bb92439"}[chunkId] + ".chunk.js";
};